/**
 * VNP cart “added” feedback — Maximize 1.8.0
 * On SUCCESSFUL add: fly a token from the ATC button to the header cart,
 * pulse the bubble, show a short toast.
 *
 * NEVER open the cart drawer. NEVER add mini-cart-open. NEVER click #cart-icon
 * or navigate to /cart. Cart-bot magazine / promo offers live on the full
 * /cart page; Enable cart drawer must stay OFF.
 *
 * Do not preventDefault or submit forms (Elspw vet-diet modal owns those).
 * pointerdown/click only remember the ATC button rect so the fly can start
 * from the original button after Accept.
 */
(function () {
  if (window.__vnpCartAddedFeedback) return;
  window.__vnpCartAddedFeedback = true;

  var DEBOUNCE_MS = 800;
  var TOAST_MS = 2400;
  var FLY_MS = 600;
  var ORIGIN_MAX_AGE_MS = 120000;
  var lastFire = 0;
  var lastCount = readCount();
  var primed = false;
  var lastAtcEl = null;
  var lastAtcRect = null;
  var lastAtcAt = 0;

  function readCount() {
    var el = document.querySelector("[data-count-item]");
    if (!el) return 0;
    var n = parseInt(el.getAttribute("data-count-item") || el.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function isAcceptOrModalChrome(el) {
    if (!el || !el.closest) return false;
    var btn = el.closest("button, input, a, [role='button']") || el;
    var txt = ((btn.textContent || btn.value || "") + "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    if (
      /^(accept|decline|cancel|close|ok)$/.test(txt) ||
      txt.indexOf("accept ") === 0
    ) {
      return true;
    }
    var modal = btn.closest('[role="dialog"], [aria-modal="true"]');
    if (modal && !btn.closest('form[action*="/cart/add"]')) return true;
    return false;
  }

  function isAtcTarget(el) {
    if (!el || !el.closest) return false;
    if (isAcceptOrModalChrome(el)) return false;
    var form = el.closest("form");
    if (form && /\/cart\/add/.test(form.getAttribute("action") || "")) {
      return true;
    }
    if (el.closest('[data-type="add-to-cart-form"]')) return true;
    if (
      el.closest(
        '[id*="AddToCart"], [id*="add-to-cart"], [class*="add-to-cart"], [class*="add_to_cart"], [name="add"]'
      )
    ) {
      return true;
    }
    var btn = el.closest('button, input[type="submit"], [role="button"]');
    if (!btn) return false;
    var bits = (
      (btn.getAttribute("name") || "") +
      " " +
      (btn.id || "") +
      " " +
      (btn.className || "") +
      " " +
      (btn.getAttribute("aria-label") || "")
    ).toLowerCase();
    if (/add.?to.?cart|addtocart/.test(bits) || btn.getAttribute("name") === "add") {
      return true;
    }
    var label = ((btn.textContent || btn.value || "") + "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    return label.indexOf("add to cart") !== -1;
  }

  function rememberAtc(e) {
    var t = e.target;
    if (!isAtcTarget(t)) return;
    var btn =
      t.closest('button, input[type="submit"], [role="button"], [name="add"]') ||
      t;
    try {
      lastAtcEl = btn;
      lastAtcRect = btn.getBoundingClientRect();
      lastAtcAt = Date.now();
    } catch (err) {}
  }

  function originRect() {
    if (!lastAtcAt || Date.now() - lastAtcAt > ORIGIN_MAX_AGE_MS) return null;
    if (lastAtcEl && lastAtcEl.getBoundingClientRect) {
      try {
        var live = lastAtcEl.getBoundingClientRect();
        if (live && (live.width || live.height || live.top || live.left)) {
          return live;
        }
      } catch (err) {}
    }
    return lastAtcRect;
  }

  function destEl() {
    return (
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector(".cart-bubble__container") ||
      document.querySelector("#cart-icon")
    );
  }

  function nearestProductImageSrc(el) {
    if (!el || !el.closest) return "";
    var scope =
      el.closest('[id^="ProductCard"]') ||
      el.closest(".product-card") ||
      el.closest(".product-info") ||
      el.closest('[data-type="add-to-cart-form"]') ||
      el.closest('form[action*="/cart/add"]') ||
      el.closest(".product");
    if (!scope) return "";
    var img = scope.querySelector(
      ".product-card__image-wrapper img, .product-card img, .product-info img, img"
    );
    if (!img) return "";
    return img.currentSrc || img.src || "";
  }

  function pulseBubble(strong) {
    var bubble = destEl();
    if (!bubble) return;
    var cls = strong ? "vnp-cart-pulse-strong" : "vnp-cart-pulse";
    bubble.classList.remove("vnp-cart-pulse", "vnp-cart-pulse-strong");
    void bubble.offsetWidth;
    bubble.classList.add(cls);
    window.setTimeout(function () {
      bubble.classList.remove("vnp-cart-pulse", "vnp-cart-pulse-strong");
    }, strong ? 900 : 700);
  }

  function flyThenPulse() {
    if (prefersReducedMotion()) {
      pulseBubble(true);
      return;
    }

    var origin = originRect();
    var dest = destEl();
    if (!origin || !dest) {
      pulseBubble(false);
      return;
    }

    var destRect = dest.getBoundingClientRect();
    var ox = origin.left + origin.width / 2;
    var oy = origin.top + origin.height / 2;
    var dx = destRect.left + destRect.width / 2 - ox;
    var dy = destRect.top + destRect.height / 2 - oy;

    var existing = document.getElementById("vnp-cart-fly-token");
    if (existing) existing.remove();

    var token = document.createElement("div");
    token.id = "vnp-cart-fly-token";
    token.className = "vnp-cart-fly-token";
    token.setAttribute("aria-hidden", "true");
    var src = nearestProductImageSrc(lastAtcEl);
    if (src && src.indexOf("data:") !== 0) {
      token.style.backgroundImage = "url(" + JSON.stringify(src) + ")";
    } else {
      token.classList.add("is-dot");
    }
    token.style.left = ox + "px";
    token.style.top = oy + "px";
    token.style.setProperty("--vnp-dx", dx + "px");
    token.style.setProperty("--vnp-dy", dy + "px");
    document.body.appendChild(token);

    window.setTimeout(function () {
      token.classList.add("is-flying");
    }, 16);

    window.setTimeout(function () {
      token.remove();
      pulseBubble(false);
    }, FLY_MS + 40);
  }

  function showToast() {
    var existing = document.getElementById("vnp-cart-added-toast");
    if (existing) existing.remove();

    var toast = document.createElement("div");
    toast.id = "vnp-cart-added-toast";
    toast.className = "vnp-cart-added-toast";
    toast.setAttribute("role", "status");
    toast.textContent = "Added to cart";
    document.body.appendChild(toast);

    window.setTimeout(function () {
      toast.classList.add("is-out");
    }, TOAST_MS - 280);
    window.setTimeout(function () {
      toast.remove();
    }, TOAST_MS);
  }

  function fireAdded() {
    var now = Date.now();
    if (now - lastFire < DEBOUNCE_MS) return;
    lastFire = now;
    flyThenPulse();
    showToast();
  }

  function maybeCountIncrease() {
    var next = readCount();
    if (primed && next > lastCount) fireAdded();
    lastCount = next;
    primed = true;
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = String(url);
      if (path.charAt(0) === "/") path = location.origin + path;
      var u = new URL(path, location.origin);
      return /\/cart\/add(\.js)?$/.test(u.pathname);
    } catch (e) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }
  }

  document.addEventListener("pointerdown", rememberAtc, true);
  document.addEventListener("click", rememberAtc, true);

  var origFetch = window.fetch;
  if (typeof origFetch === "function") {
    window.fetch = function () {
      var args = arguments;
      var input = args[0];
      var url = typeof input === "string" ? input : input && input.url;
      return origFetch.apply(this, args).then(function (res) {
        if (res && res.ok && isCartAddUrl(url)) fireAdded();
        return res;
      });
    };
  }

  var OrigXHR = window.XMLHttpRequest;
  if (OrigXHR && OrigXHR.prototype) {
    var origOpen = OrigXHR.prototype.open;
    var origSend = OrigXHR.prototype.send;
    OrigXHR.prototype.open = function (method, url) {
      this.__vnpCartAdd = isCartAddUrl(url);
      return origOpen.apply(this, arguments);
    };
    OrigXHR.prototype.send = function () {
      if (this.__vnpCartAdd) {
        this.addEventListener("load", function () {
          if (this.status >= 200 && this.status < 300) fireAdded();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  document.addEventListener("maximize:cart:updated", function () {
    maybeCountIncrease();
  });

  var countEl = document.querySelector("[data-count-item]");
  if (countEl && typeof MutationObserver === "function") {
    new MutationObserver(maybeCountIncrease).observe(countEl, {
      attributes: true,
      attributeFilter: ["data-count-item"],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      lastCount = readCount();
      primed = true;
    });
  } else {
    primed = true;
  }
})();
